export default "__VITE_ASSET__b0a7c9a7__"